module.exports = global["pdfMake"] = require("-!c:\\Users\\Libor\\Documents\\GitHub\\pdfmake\\node_modules\\babel-loader\\lib\\index.js??ref--4!.\\pdfMake.js");